const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-luxury-cream relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gold/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 lg:px-20 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Right Side - Images */}
          <div className="relative order-2 lg:order-1">
            <div className="relative">
              {/* Main Image */}
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/be9b8f1ee61a4631c0facb7002a3a72d.jpg"
                  alt="سيارة فاخرة"
                  className="w-full h-[400px] object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>
              
              {/* Small Image Overlay */}
              <div className="absolute -bottom-8 -left-8 w-64 h-48 rounded-2xl overflow-hidden shadow-xl border-4 border-white">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20saudi%20driver%20in%20traditional%20white%20thobe%20standing%20confidently%20next%20to%20luxury%20black%20car%2C%20friendly%20smile%2C%20modern%20professional%20photography%2C%20clean%20background%2C%20premium%20transportation%20service%2C%20warm%20lighting%2C%20trustworthy%20atmosphere%2C%20golden%20hour&width=400&height=300&seq=driver-professional-002&orientation=landscape"
                  alt="سائق محترف"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              {/* Decorative Gold Element */}
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-gold to-gold/70 rounded-3xl -z-10 rotate-12"></div>
              <div className="absolute -bottom-12 -right-12 w-40 h-40 border-4 border-gold/30 rounded-3xl -z-10"></div>
            </div>
            
            {/* Stats Cards */}
            <div className="grid grid-cols-2 gap-4 mt-16">
              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 text-center">
                <div className="text-gold font-almarai font-black text-4xl mb-2">8+</div>
                <div className="text-luxury-gray font-cairo text-sm">سنوات خبرة</div>
              </div>
              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 text-center">
                <div className="text-gold font-almarai font-black text-4xl mb-2">5000+</div>
                <div className="text-luxury-gray font-cairo text-sm">عميل راضٍ</div>
              </div>
            </div>
          </div>

          {/* Left Side - Content */}
          <div className="text-right order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 bg-gold/10 px-4 py-2 rounded-full mb-6">
              <i className="ri-star-fill text-gold text-sm"></i>
              <span className="text-gold font-cairo font-bold text-sm">الأفضل في المملكة</span>
            </div>
            
            <h3 className="text-luxury-black font-almarai font-black text-4xl lg:text-5xl mb-6 leading-tight">
              عن <span className="text-gold">فخامة الرفاهية</span>
            </h3>
            
            <div className="w-24 h-1.5 bg-gradient-to-l from-gold to-gold/50 mb-8"></div>
            
            <p className="text-luxury-gray font-cairo text-lg leading-relaxed mb-6">
              نحن في <strong className="text-luxury-black">فخامة الرفاهية للتوصيل</strong> نفخر بتقديم خدمات نقل فاخرة ومتميزة للحجاج والمعتمرين من مطار الملك عبدالعزيز الدولي بجدة إلى مكة المكرمة والمدينة المنورة والمزارات الدينية المقدسة.
            </p>
            
            <p className="text-luxury-gray font-cairo text-lg leading-relaxed mb-8">
              مع أسطول من السيارات الفاخرة وفريق من السائقين المحترفين ذوي الخبرة، نضمن لك رحلة آمنة ومريحة تليق بمكانة رحلتك الروحانية.
            </p>

            {/* Features List */}
            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-4 text-right">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gold/20 rounded-xl">
                  <i className="ri-shield-check-line text-gold text-xl"></i>
                </div>
                <div>
                  <h4 className="text-luxury-black font-cairo font-bold text-lg mb-1">أمان وموثوقية</h4>
                  <p className="text-luxury-gray font-cairo text-sm">سائقون مرخصون مع سجل قيادة نظيف</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 text-right">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gold/20 rounded-xl">
                  <i className="ri-time-line text-gold text-xl"></i>
                </div>
                <div>
                  <h4 className="text-luxury-black font-cairo font-bold text-lg mb-1">خدمة 24/7</h4>
                  <p className="text-luxury-gray font-cairo text-sm">نعمل على مدار الساعة لخدمتكم</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 text-right">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gold/20 rounded-xl">
                  <i className="ri-vip-crown-line text-gold text-xl"></i>
                </div>
                <div>
                  <h4 className="text-luxury-black font-cairo font-bold text-lg mb-1">رفاهية وفخامة</h4>
                  <p className="text-luxury-gray font-cairo text-sm">أسطول من أحدث السيارات الفاخرة</p>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <a
              href="/about"
              className="inline-flex items-center gap-3 bg-gradient-to-l from-gold to-gold/90 hover:from-gold/90 hover:to-gold text-white font-cairo font-bold text-lg px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <span>اكتشف المزيد عنا</span>
              <i className="ri-arrow-left-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
